import { z } from 'zod';
import { idSchema, isoDateSchema, isoDateTimeSchema, isoTimeSchema } from './common.js';
import { taskInputSchema, taskSchema } from './task.js';
export const couvertTypeSchema = z.enum(['free', 'free_until', 'flat']);
export const eventStatusSchema = z.enum(['draft', 'published', 'cancelled']);
// Item do line-up dentro de um evento (não é o catálogo).
export const lineupItemSchema = z.object({
    attraction_id: idSchema.nullable().optional(),
    name: z.string().min(1).max(120),
    time: isoTimeSchema.nullable().optional(),
});
export const eventInputSchema = z.object({
    brand_id: idSchema.default(1),
    name: z.string().min(2).max(160),
    event_date: isoDateSchema,
    open_time: isoTimeSchema.nullable(),
    close_time: isoTimeSchema.nullable(),
    attractions: z.array(lineupItemSchema).default([]),
    // djs mantido pra compat com dados antigos; novos eventos usam attractions[].
    djs: z.string().max(500).nullable(),
    couvert_type: couvertTypeSchema.default('flat'),
    couvert_value: z.number().nonnegative().nullable(),
    couvert_until: isoTimeSchema.nullable(),
    highlight: z.string().max(160).nullable(),
    promos: z.string().max(2000).nullable(),
    cover_image_url: z.string().url().max(500).nullable(),
    status: eventStatusSchema.default('published'),
    tasks: z.array(taskInputSchema).optional(),
});
export const eventSchema = eventInputSchema
    .omit({ tasks: true })
    .extend({
    id: idSchema,
    created_by: idSchema,
    updated_by: idSchema,
    created_at: isoDateTimeSchema,
    updated_at: isoDateTimeSchema,
    tasks: z.array(taskSchema).optional(),
});
//# sourceMappingURL=event.js.map